import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  KivuI18nContext,
  localizedPath,
  ALERT_BANNER_CODE,
  ALERT_BANNER_CODE_SEVERITY,
  API_RESPONSE_CODE
} from "@kivunova/kivufrontendcommon";
import { AUTH_STATUS } from "../../context/enums/authEnums";
import AuthContext from "../../context/authContext";
import { LogoutResponse } from "../../Graphql/types/auth";
import { logoutQuery } from "../../Graphql/querries/logoutQuery";
import { useNavigate } from "react-router-dom";
import { PAGE_ROUTE_LOGIN } from "@kivunova/kivufrontendcommon";

const useLogout = () => {
  const { setAlert } = useContext(AlertBannerContext);
  const { authContextInfo, updateAuthContextInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const { language, defaultLang } = useContext(KivuI18nContext);

  return useMutation<LogoutResponse, Error>({
    mutationKey: ["logout"],
    mutationFn: () => fetchGraphQL(logoutQuery, { input: {} }, setAlert),
    onSuccess: (response) => {
      const { code } = response.logout;

      if (code === API_RESPONSE_CODE.OK) {
        updateAuthContextInfo({
          ...authContextInfo,
          auth: {
            status: AUTH_STATUS.UNAUTHENTICATED
          }
        });

        // redirect to login after logging out successfully
        navigate(localizedPath(PAGE_ROUTE_LOGIN, language, defaultLang));
      } else {
        setAlert({
          severity: ALERT_BANNER_CODE_SEVERITY.ERROR,
          code: code
            ? (code as unknown as ALERT_BANNER_CODE)
            : ALERT_BANNER_CODE.INTERNAL_ERROR
        });

        throw new Error(code);
      }
    }
  });
};

export default useLogout;
